import request from '@/utils/request'

const RESOURCE_BASE_PATH = '/users'

export function lists(query) {
  return request({
    url: RESOURCE_BASE_PATH,
    method: 'get',
    params: query
  })
}

export function get(id, query) {
  return request({
    url: `${RESOURCE_BASE_PATH}/${id}`,
    method: 'get',
    params: query
  })
}

export function getMe() {
  return request({
    url: `/EviUser/getUserInfo`,
    method: 'get'
  })
}

export function post(data) {
  return request({
    url: RESOURCE_BASE_PATH,
    method: 'post',
    data: data
  })
}

export function put(id, data) {
  return request({
    url: `${RESOURCE_BASE_PATH}/${id}`,
    method: 'put',
    data: data
  })
}

export function patch(id, data) {
  return request({
    url: `${RESOURCE_BASE_PATH}/${id}`,
    method: 'patch',
    data: data
  })
}

export function remove(id) {
  return request({
    url: `${RESOURCE_BASE_PATH}/${id}`,
    method: 'delete'
  })
}

export function putStatus(id, user_status) {
  return request({
    url: `${RESOURCE_BASE_PATH}/${id}/status`,
    method: 'put',
    data: {
      user_status
    }
  })
}

export function putPassword(id, password) {
  return request({
    url: `${RESOURCE_BASE_PATH}/${id}/password`,
    method: 'put',
    data: {
      password
    }
  })
}

export function putRoles(id, role_ids) {
  return request({
    url: `${RESOURCE_BASE_PATH}/${id}/roles`,
    method: 'put',
    data: {
      role_ids: role_ids
    }
  })
}

